import { render, staticRenderFns } from "./FacilitiesPaginated.vue?vue&type=template&id=b02188ba&scoped=true"
import script from "./FacilitiesPaginated.vue?vue&type=script&lang=js"
export * from "./FacilitiesPaginated.vue?vue&type=script&lang=js"
import style0 from "./FacilitiesPaginated.vue?vue&type=style&index=0&id=b02188ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02188ba",
  null
  
)

export default component.exports